var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 821 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.1507,
    cy: 68.1507,
    r: 68.1507,
    fill: "#5571D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 160.006H136.301V505.546V505.546C61.0243 505.546 0 444.522 0 369.245V160.006Z",
    fill: "#5571D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.622 136.301C364.261 136.301 394.773 105.789 394.773 68.1507C394.773 30.5121 364.261 0 326.622 0C288.983 0 258.471 30.5121 258.471 68.1507C258.471 105.789 288.983 136.301 326.622 136.301ZM326.5 15C354.943 15 378 38.7289 378 68C378 97.2711 354.943 121 326.5 121C298.057 121 275 97.2711 275 68C275 38.7289 298.057 15 326.5 15Z",
    fill: "#BACDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272 160H383V506V506C321.696 506 272 456.304 272 395V160Z",
    fill: "#BACDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.301 264.625L136.301 160.006L648.23 160.006L648.23 264.625L136.301 264.625Z",
    fill: "#BACDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821 333.228C821 333.078 821 332.927 821 332.776C821 237.358 743.648 160.006 648.23 160.006C552.812 160.006 475.46 237.358 475.46 332.776C475.46 428.194 552.812 505.546 648.23 505.546C648.322 505.546 648.413 505.546 648.505 505.546H821V333.228ZM716.38 333.002C716.38 332.926 716.381 332.851 716.381 332.776C716.381 295.137 685.868 264.625 648.23 264.625C610.591 264.625 580.079 295.137 580.079 332.776C580.079 370.414 610.591 400.926 648.229 400.926V400.927H716.38L716.38 333.002Z",
    fill: "#BACDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideLogo);
export default __webpack_public_path__ + "static/media/aside-logo.dc649547e18e69a129777e5a6bc55a62.svg";
export { ForwardRef as ReactComponent };